import { render, staticRenderFns } from "./GeneralItems.vue?vue&type=template&id=b2d45f58&scoped=true"
import script from "./GeneralItems.vue?vue&type=script&lang=js"
export * from "./GeneralItems.vue?vue&type=script&lang=js"
import style0 from "./GeneralItems.vue?vue&type=style&index=0&id=b2d45f58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d45f58",
  null
  
)

export default component.exports